<template>

  <v-autocomplete v-model="form.share_theme_id"
                  v-if="team.sharing_enabled && (form.settings.can_be_shared || form.settings.can_be_shared_link)"
                  clearable
                  label="Share Theme"
                  placeholder=" "
                  hint="When a user shares this presentation with someone, the recipient will click a link and it will take them t a web page that has this theme. Leave it blank to use the default share theme."
                  :items="filteredShareThemes"
                  item-value="id"
                  item-text="name">
  </v-autocomplete>
</template>
<script>
import {mapGetters} from 'vuex';
import clone from 'lodash/clone';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'shareThemes',
      'team',
      'user',
      'users',
    ]),

    filteredShareThemes() {
      const themes = clone(this.shareThemes);
      themes.unshift({id: '', name: 'Use the default'});
      return themes;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchShareThemes');
    },
  }
}
</script>
